import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogGuidePage from "../pages/blog/pandabuy-spreadsheet-guide/page";
import ShoesArticle from "../pages/blog/pandabuy-spreadsheet-shoes/page";
import HoodiesArticle from "../pages/blog/pandabuy-spreadsheet-hoodies/page";
import TShirtsArticle from "../pages/blog/pandabuy-spreadsheet-tshirts/page";
import JacketsArticle from "../pages/blog/pandabuy-spreadsheet-jackets/page";
import AccessoriesArticle from "../pages/blog/pandabuy-spreadsheet-accessories/page";
import BagsArticle from "../pages/blog/pandabuy-spreadsheet-bags/page";
import TrendsArticle from "../pages/blog/pandabuy-spreadsheet-trends/page";
import SafetyArticle from "../pages/blog/pandabuy-spreadsheet-safety/page";
import BeginnersArticle from "../pages/blog/pandabuy-spreadsheet-beginners/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pandabuy-spreadsheet-guide",
    element: <BlogGuidePage />,
  },
  {
    path: "/pandabuy-spreadsheet-shoes",
    element: <ShoesArticle />,
  },
  {
    path: "/pandabuy-spreadsheet-hoodies",
    element: <HoodiesArticle />,
  },
  {
    path: "/pandabuy-spreadsheet-tshirts",
    element: <TShirtsArticle />,
  },
  {
    path: "/pandabuy-spreadsheet-jackets",
    element: <JacketsArticle />,
  },
  {
    path: "/pandabuy-spreadsheet-accessories",
    element: <AccessoriesArticle />,
  },
  {
    path: "/pandabuy-spreadsheet-bags",
    element: <BagsArticle />,
  },
  {
    path: "/pandabuy-spreadsheet-trends",
    element: <TrendsArticle />,
  },
  {
    path: "/pandabuy-spreadsheet-safety",
    element: <SafetyArticle />,
  },
  {
    path: "/pandabuy-spreadsheet-beginners",
    element: <BeginnersArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;